import { Grid, IconButton, InputAdornment } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { useCallback, useEffect } from "react";
import { AutocompleteInput, number, ReferenceInput, TextInput, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
// var programmePath = "";

export const EpisodeSearch = (props) => {
  const { formData, canRemoveProgramme } = props;
  const rest = props.rest;

  // reset the form into initial values
  const form = useForm();
  const dataProvider = useDataProvider();

  // check change of programme_id , fetch programme name , fill the field
  useEffect(async () => {
    if (formData.programme_id) {
      const result = await dataProvider.getProgrammeByProgrammeId(parseInt(formData.programme_id));

      if (result && result.data && result.data.name_tc) {
        form.change("title_tc", result.data.name_tc);
        form.change("title_en", result.data.name_en);

        // Auto complete "destination_url"
        // programmePath = result.data.path;
        // form.change("destination_url", mytvsuperUrl + "/programme/" + programmePath + "/");
      }
    } else {
      form.change("title_tc", "");
      form.change("title_en", "");
    }
  }, [formData.programme_id]);

  const fetchProgramme = useCallback(async () => {});

  const handleRemove = () => {
    form.change("programme_id", undefined);
  };

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={6}>
        <AutoCompleteProgramme clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} fetchProgramme={fetchProgramme} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput
          label="Content ID"
          source="programme_id"
          disabled
          fullWidth
          InputProps={{
            endAdornment: canRemoveProgramme ? (
              <InputAdornment position="end">
                <IconButton onClick={handleRemove} edge="end" style={{ color: "red" }}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ) : (
              <></>
            ),
          }}
        />
      </Grid>
      {/* <Grid item sm={12} md={6}>
        <TextInput label="Episode ID" source="episode_id_for_url" disabled fullWidth />
      </Grid> */}
      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in TC *" source="title_tc" disabled fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in EN *" source="title_en" disabled fullWidth />
        </Grid>
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Episode No." source="episode_no" validate={number()} fullWidth />
      </Grid>

      {/* <Grid item sm={12} md={6}>
        <AutoCompleteEpisode clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Episode" source="episode_text" disabled fullWidth />
      </Grid> */}
    </Grid>
  );
};

const AutoCompleteProgramme = (props) => {
  const form = useForm();

  useEffect(() => {});

  return (
    <ReferenceInput
      label="Search Programme Name"
      source="programme_autocomplete"
      reference="programmes-autocomplete"
      onChange={(val) => {
        props.fetchProgramme(val);

        form.change("programme_id", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="programme_id" fullWidth />
    </ReferenceInput>
  );
};
